var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_36407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4485_36407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 56,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9615 7H4V57H59.9615V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4485_36407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23077 49.8528L10.6987 54.1157C11.2115 55.0131 11.9487 55.7182 12.8141 56.231L21.6282 40.9746H4C4 41.9682 4.25641 42.9618 4.76923 43.8592L8.23077 49.8528Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9807 23.026L23.1667 7.76953C22.3013 8.28235 21.5641 8.98748 21.0513 9.88492L4.76923 38.0901C4.26584 38.9682 4.00067 39.9625 4 40.9747H21.6282L31.9807 23.026Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1474 56.231C52.0128 55.7182 52.75 55.0131 53.2628 54.1157L54.2885 52.3528L59.1925 43.8592C59.705 42.9618 59.9615 41.9682 59.9615 40.9746H42.332L46.0833 48.3464L51.1474 56.231Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9811 23.0257L40.7952 7.76923C39.9298 7.25641 38.9362 7 37.9106 7H26.0516C25.026 7 24.0324 7.28846 23.167 7.76923L31.9811 23.0257Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3337 40.9746H21.6286L12.8145 56.231C13.6799 56.7439 14.6735 57.0003 15.6991 57.0003H48.2632C49.2888 57.0003 50.2824 56.7118 51.1478 56.231L42.3337 40.9746Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.051 23.9875L42.91 9.88492C42.3972 8.98748 41.66 8.28235 40.7946 7.76953L31.9805 23.026L42.3331 40.9747H59.9292C59.9292 39.9811 59.6727 38.9875 59.1602 38.0901L51.051 23.9875Z",
    fill: "#FFBA00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_36407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 50,
    fill: "white",
    transform: "translate(4 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/googleDrive.fc0fd93c54d938b7dba08d2d86c8cece.svg";
export { ForwardRef as ReactComponent };